var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},on:{"input":_vm.onContentChange},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})}
var staticRenderFns = []

export { render, staticRenderFns }